import { useQuery } from "@tanstack/react-query";
import { PurchaseOrderService } from "src/services";
import { APIError } from "src/errors";
import { queryKeys } from "src/constants";
import { POCompletionStatus } from "src/types";

export const usePurchaseOrder = (
  purchaseOrderId: string,
  purchaseOrderService: PurchaseOrderService,
  completionStatus?: POCompletionStatus
) => {
  const {
    data: purchaseOrder,
    error: fetchError,
    isLoading,
    refetch
  } = useQuery({
    queryKey: queryKeys.purchaseOrder(purchaseOrderId, completionStatus),
    queryFn: async () => {
      try {
        return await purchaseOrderService.getPurchaseOrderById(purchaseOrderId, completionStatus);
      } catch (error) {
        if (error instanceof APIError && error.statusCode === 404) {
          return null;
        }
        throw error;
      }
    },
    enabled: !!purchaseOrderId,
    retry: false
  });

  return { purchaseOrder, fetchError, isLoading, refetch };
};
